import type { SagaIterator } from 'redux-saga';
import { takeEvery, takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './subscriptionsActions';
import {
  mkSubscription,
  type SubscriptionProps,
  type UpdateSubscriptionRenewalFrequencyPayload,
} from './subscriptionsTypes';

type SubscriptionsResponse = {
  data?: SubscriptionProps[] | { resources?: SubscriptionProps[] };
};

const mkSubscriptionsResourceConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<SubscriptionProps>();
const mkSubscriptionRenewalFrequencyResourceConfig =
  resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<UpdateSubscriptionRenewalFrequencyPayload>();

const mkResourceConfig = () =>
  mkSubscriptionsResourceConfig({
    resourceName: 'subscriptions',
    resourceBaseUrl: '/subscriptions',
    axiosConfig: { headers: { 'qcs-dataset-id': null } },
    transformResponseToResources: (response?: SubscriptionsResponse | null) => {
      const data = response?.data;
      const subscriptions = Array.isArray(data) ? data : data?.resources;
      return subscriptions?.map((subscription) => mkSubscription(subscription));
    },
    successAction: actions.getSubscriptionsSuccess,
    failureAction: actions.getSubscriptionsFailure,
  });

export function* getSubscriptionActionWatcher(): SagaIterator {
  const resourceConfig = mkResourceConfig();
  yield takeLeading(
    actions.getSubscriptions.type,
    resourceSagaUtils.qcsSyncGetResources<SubscriptionProps>,
    resourceConfig,
  );
}

export function* updateSubscriptionRenewalFrequencyActionWatcher(): SagaIterator {
  const resourceConfig = mkSubscriptionRenewalFrequencyResourceConfig({
    resourceName: 'subscriptionsActions',
    resourceBaseUrl: '/subscriptions/renewalFrequency',
    axiosConfig: { headers: { 'qcs-dataset-id': null } },
    successAction: actions.updateSubscriptionRenewalFrequencySuccess,
    failureAction: actions.updateSubscriptionRenewalFrequencyFailure,
  });
  yield takeEvery(
    actions.updateSubscriptionRenewalFrequency.type,
    resourceSagaUtils.qcsSyncCreateResource<UpdateSubscriptionRenewalFrequencyPayload>,
    resourceConfig,
  );
}

export default [getSubscriptionActionWatcher, updateSubscriptionRenewalFrequencyActionWatcher];
